import { render, staticRenderFns } from "./ShopCart.vue?vue&type=template&id=c3511c9c&"
import script from "./ShopCart.vue?vue&type=script&lang=js&"
export * from "./ShopCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports